import { BaseModel, attr, belongsTo } from "../../lib/itn-ui-kit/data";

export default class ActionableItem extends BaseModel {
  static urlPath = "actionable_items";

  @belongsTo("case") onCase;
  @attr("json") actingUser;
  @belongsTo("lawfirm") onFirm;
  @attr("boolean") call_associated;
  @attr("string") relativeDueDate;
  @attr("string") clockState;
  @attr("string") createdAt;
  @attr("string") updatedAt;
  @attr("string") actionDetail;
  @attr("string") dueDate;
  @attr("string") status;
  @attr("string") actionType;
  @attr("string") completedAt;
  @attr("string") updatedBy;
  @attr("string") priority;
  @attr("datetime") priorityDate;
  @attr("array") relatedValidations;
  @belongsTo("client") createdBy;
  @belongsTo("client") completedBy;
  @belongsTo("provider") onProvider;
}
